var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',_vm._b({on:{"click":function($event){$event.preventDefault();return _vm.clickHandler($event)}}},'img',{ src: _vm.resizedImageUrl },false))}
var staticRenderFns = []

export { render, staticRenderFns }